import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { BuildingService } from '@services/buildings.service';

import { loadBuildings, loadBuildingsFailure, loadBuildingsSuccess } from './buildings.actions';

@Injectable()
export class BuildingsEffects {
  private readonly actions$ = inject(Actions);
  private readonly buildingService = inject(BuildingService);

  getBuildings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadBuildings),
      mergeMap(() =>
        this.buildingService.list().pipe(
          map((buildings) => loadBuildingsSuccess({ list: buildings })),
          catchError((error) => of(loadBuildingsFailure({ error: error.message }))),
        ),
      ),
    ),
  );
}
